import React from "react";

const TitleUnderlined = (props) => {
    return (
        <span className={`text-uppercase title-underlined divider title ${props.className}`}>{props.children}</span>
    )
}

export default TitleUnderlined;